
import clone from 'lodash/clone'

export default {

    computed: {
        /**
         * @returns {Array<NavigationLink>}
         */
        subnavItems() {
            const loggingCategory = 'Loading Menu Items'
            this.$logger.logObject({ items: this.$scheme.navigationItems, scheme: this.$scheme }, 'Navigation Items from scheme', loggingCategory)

            if (this.$scheme.navigationItems.length < 1) return []
            const sortedLinks = clone(this.$scheme.navigationItems)

            sortedLinks.sort((firstEl, secondEl) => {
                return firstEl.order - secondEl.order
            })

            const retVal = sortedLinks.map((item, idx) => {
                item.key = idx
                return item
            })
            this.$logger.logObject({ items: retVal }, 'Sorted Keyed Items', loggingCategory)

            return retVal
        },
    },
}
